<ion-content [fullscreen]="true" class="background">

  <ion-grid>
    <ion-row>
      <ion-col class="ion-align-items-center ion-text-center">
        <div class="page__heading ion-margin-top">
          <div class="page__heading-title">
            <ion-text i18n>I miei ballottaggi</ion-text>
          </div>
          <div class="page__heading-subtitle">
            <ion-text i18n>{{pageTitle}}</ion-text>
          </div>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>

  <!--
      COPPIE DI BALLOTTAGGI, COL CICLO DELLE VOTAZIONI : COMPONENTE ELIMINATO IL 26/6/2021
                            <app-my-ballots-pairs></app-my-ballots-pairs>
    -->
  <div *ngIf="showBallotsPair; else showBallotsWithVotes">
    <!--
          COPPIE DI BALLOTTAGGI, PER LA SELEZIONE
        -->

    <ion-grid *ngIf="ballotsPair?.length==0">
      <ion-row>
        <ion-col class="ion-align-items-center ion-text-center">
          <div class="page__heading ion-margin-top">
            <div class="page__heading-title">
              <ion-text i18n>Non hai inserito nessun ballottaggio</ion-text>
            </div>
            <!-- <div class="page__heading-subtitle">
                  <ion-text i18n>{{pageTitle}}</ion-text>
                </div> -->
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>

    <ion-grid>
      <ion-row *ngIf="countdown!=''">
        <ion-col class="ion-align-items-center ion-text-center">
          <div class="page__heading-title">
            <ion-text i18n>{{countdown}} al reset</ion-text>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>

    <ion-grid *ngFor="let ballotPair of ballotsPair">
      <ion-row>
        <!-- BALLOTTAGGI SINISTRA -->
        <ion-col size="6">
          <ion-card color="primary" id="ballot-{{ballotPair.left.id}}"
            [ngClass]="{'animate__animated animate__bounceOutLeft animate__delay-2s animate__slower': animateBeforeDelete && animateBeforeDeleteBallotId === ballotPair.left.id, 'boosted': !!ballotPair.left.boosted }">
            <ion-grid>
              <ion-row>
                <ion-col size="4">
                  <ion-button (click)="delete(ballotPair.left.id)" id="delete-{{ballotPair.left.id}}" [hidden]="hidden"
                    color="danger" class="delete-round-button ion-no-padding ion-no-margin ">
                    <ion-icon name="close-outline" slot="icon-only"></ion-icon>
                  </ion-button>
                </ion-col>
                <ion-col size="8" class="ion-align-items-center ion-align-self-center ion-text-center">
                  <ion-card-header class="ion-no-padding">
                    <ion-card-subtitle>
                      <ion-text>
                        {{ ballotPair.left.dstype }}
                        <br>
                        {{ ballotPair.left.dsmatrix }}
                      </ion-text>
                    </ion-card-subtitle>
                  </ion-card-header>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col size="12" class="scrollbox">
                  <div *ngFor="let p of ballotPair.left.surnames">
                    <ion-grid class="ion-no-padding">
                      <ion-row>
                        <ion-col class="ellipsis">
                          <span class="surname-box">{{ p }}</span>
                        </ion-col>
                      </ion-row>
                    </ion-grid>
                  </div>
                </ion-col>
              </ion-row>
            </ion-grid>

            <ion-footer class="ion-align-items-center ion-align-self-center ion-text-center">
              <!-- <div style="vertical-align: bottom;">xxxxxxxxxxxxxxxxxx</div> -->

              <ion-button (click)="showSingleBallotWithVotation(ballotPair.left.id)"
                id="aggiorna-{{ballotPair.left.id}}" class="gradient__primary-secondary-135">
                <ion-icon name="refresh-outline"></ion-icon>
              </ion-button>
              <ion-button (click)="showSingleBallotWithoutVotation(ballotPair.left.id)"
                id="resize-{{ballotPair.left.id}}" class="gradient__primary-secondary-135 btn-resize">
                <ion-icon name="resize"></ion-icon>
              </ion-button>
              <app-boost [ballot]="ballotPair.left" [loggedUser]="loggedUser" [freeBoost]="loggedUser.boosts"></app-boost>

            </ion-footer>
          </ion-card>
        </ion-col>

        <!-- BALLOTTAGGI DESTRA *ngIf="ballotPair.rigth.id > 0" -->
        <ion-col size="6">
          <ion-card *ngIf="ballotPair.rigth.id > 0" id="ballot-{{ballotPair.rigth.id}}" color="primary"
            [ngClass]="{'animate__animated animate__bounceOutRight animate__delay-1s animate__slower': animateBeforeDelete && animateBeforeDeleteBallotId === ballotPair.rigth.id,  'boosted': !!ballotPair.rigth.boosted }">
            <ion-grid>
              <ion-row>
                <ion-col size="4">
                  <ion-button (click)="delete(ballotPair.rigth.id)" id="delete-{{ballotPair.rigth.id}}" color="danger"
                    class="delete-round-button ion-no-padding ion-no-margin">
                    <ion-icon name="close-outline" slot="icon-only"></ion-icon>
                  </ion-button>
                </ion-col>
                <ion-col size="8" class="ion-align-items-center ion-align-self-center ion-text-center">
                  <ion-card-header class="ion-no-padding">
                    <ion-card-subtitle>
                      <ion-text>
                        {{ ballotPair.rigth.dstype }}
                        <br>
                        {{ ballotPair.rigth.dsmatrix }}
                      </ion-text>
                    </ion-card-subtitle>
                  </ion-card-header>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col size="12" class="scrollbox">
                  <div *ngFor="let p of ballotPair.rigth.surnames">
                    <ion-grid class="ion-no-padding">
                      <ion-row>
                        <ion-col class="ellipsis">
                          <span class="surname-box">{{ p }}</span>
                        </ion-col>
                      </ion-row>
                    </ion-grid>
                  </div>
                </ion-col>
              </ion-row>
            </ion-grid>
            <ion-footer class="ion-align-items-center ion-align-self-center ion-text-center">
              <!-- <div style="vertical-align: bottom;">xxxxxxxxxxxxxxxxxx</div> -->

              <ion-button (click)="showSingleBallotWithVotation(ballotPair.rigth.id)"
                id="aggiorna-{{ballotPair.rigth.id}}" class="gradient__primary-secondary-135">
                <ion-icon name="refresh-outline"></ion-icon>
              </ion-button>
              <ion-button (click)="showSingleBallotWithoutVotation(ballotPair.rigth.id)"
                id="resize-{{ballotPair.rigth.id}}" class="gradient__primary-secondary-135 btn-resize">
                <ion-icon name="resize"></ion-icon>
              </ion-button>
              <app-boost [ballot]="ballotPair.rigth" [loggedUser]="loggedUser" [freeBoost]="loggedUser.boosts"></app-boost>

            </ion-footer>
          </ion-card>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
  <ng-template #showBallotsWithVotes>
    <!--
          BALLOTTAGGIO COL VOTO E IL CICLO DELLE VOTAZIONI
        -->
    <!-- <app-my-ballot [ballot]="ballot"></app-my-ballot> -->

    <app-my-ballot [ballot]="ballot" [loggedUser]="loggedUser" [showVotesOf]="showVotesOf" [showVotesBeforeBallot]="showVotesBeforeBallot"
      (returnToBallotsPairEvent)="returnedFromBallotComponent($event)">
    </app-my-ballot>
  </ng-template>

  <div class="spacer-150"></div>
</ion-content>